import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_3: FaireProductEntity = {
  token: "nyc-snack-3",
  type: "product",
  name: "Dry Cookie Mix - Starter Kit",
  brandName: "Homemade-ish",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  priceDollars: 16,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  weight: 0.8,
  dimensions: {
    width: 4,
    height: 5,
    depth: 4,
  },
  description: "Premium cookie starter kit with glitter surprise inside",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "baking", "gift"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
